import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { RoadStopDetails } from '../models/road-stop-details';

/**
 * Computes the resolved itinerary (per-leg distances + Google Maps link) from
 * the addresses currently entered in the transport form, via
 * POST /api/transport/itinerary. No saved transport required, so it works while
 * creating or editing and recomputes as the user changes the itinerary.
 */
@Injectable({
  providedIn: 'root',
})
export class RoadStopDetailsService {
  private http = inject(HttpClient);

  computeItinerary(addresses: string[]): Observable<RoadStopDetails> {
    return this.http.post<RoadStopDetails>(
      `${environment.apiUrl}/transport/itinerary`,
      { addresses },
    );
  }
}
